import React,{useState,useEffect} from 'react'
import {BiChevronDown} from 'react-icons/bi'
import {AiOutlineSearch} from 'react-icons/ai'
import MwInputText from './MwInputText';
import { useFetch, useCurrent } from '../../hooks';
import { useTranslation } from 'react-i18next';

const MwSelectorWarehouses = ({selectedItem,setSelectedItem,withLabel=false,invalid=false,initalValue,disabled=false}) => {
        const [inputValue,setInputValue] = useState('');
        const [warehousesFilter,setWarehousesFilter] = useState([]);
        const [open,setOpen] = useState(false);
        const {currentTenantId,currentCompanyId,currentBranchId} = useCurrent();
        const {data:warehosesResult,loading:loadingWarehouse} = useFetch(`${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/${currentTenantId}/${currentCompanyId}/${currentBranchId}`)
                const [t,i18n ] = useTranslation('global')
        
        useEffect(() => {
            if(warehosesResult){
                setWarehousesFilter(warehosesResult?.data)
            }
        },[warehosesResult]);
    return (
        <>
        <div className='relative text-slate-600'>
            { withLabel && <label className={`text-xs text-slate-500 `} > {t('stocktaking.select_warehouse')}  </label> }
            <div 
                onClick={()=> {
                    !disabled && setOpen(!open);
                }}
                className={` h-9 bg-white w-full border flex items-center text-sm  justify-between rounded ${ !!invalid && 'border border-red-400' } ${disabled ? 'text-slate-200' : 'text-slate-300'} `}
                >
                {
                selectedItem ? 
                    <span className={` px-2 ${disabled ? ' text-slate-300' : 'text-slate-500'}`}>{selectedItem.name_ar || selectedItem.name_en }</span> : 
                    <MwInputText 
                        disabled={disabled}
                        value={initalValue}
                        classNameInput =  'text-start px-3 border-0 font-bold'
                        onChange={(e)=>{
                            setInputValue(e.target.value);
                        }
                        }
                    />
                } 
                <BiChevronDown size={20} className='border rounded m-2'/>
            </div>
             {
                warehousesFilter.length > 0 && 
                <ul className={`   bg-slate-50 border-b-2 border-x-2  z-50  overflow-y-auto absolute w-screen  md:w-full pe-12 md:pe-0  rounded-b-lg  ${open ? 'max-h-60 block' : 'max-h-0 hidden'}`}>
                    {/* <div className='sticky top-0 p-3'>
                        <div className='flex items-center justify-between  px-2  bg-white rounded '>
                            <AiOutlineSearch size={18} className='text-gray-700' />
                            <input 
                                type="text"
                                placeholder='Enter Warehouse Name '
                                className='placeholder:text-grray-700 p-2 outline-none p-3 w-full text-sm bg-white'
                                value={inputValue}
                                onChange={(e)=>setInputValue(e.target.value.toLowerCase())}
                                />
                        </div>
                    </div> */}
                    <div>
                        {warehousesFilter?.map((item)=>
                             <li 
                                key={item.id}
                                onClick={()=>{
                                    setSelectedItem(item)
                                    setOpen(false);
                                    setInputValue("")
                                }}
                                className={`ps-5 py-1 border-b text-sm  hover:bg-sky-200 hover:text-white `}> 
                                <div className='flex gap-5 justify-between'>
                                    <div>
                                        <div> {item.name_ar } </div>
                                        <div className='text-xs text-slate-400'>  {item.name_en} </div>
                                    </div>
                                </div>
                            </li>
                        )}
                    </div>
                </ul>
            }
        </div>
        </>
    )
}

export default MwSelectorWarehouses